"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogueComponentContentById = void 0;
const getCatalogueComponentContentById = (components, id) => {
    const component = components?.find((component) => component.id === id);
    if (!component?.content) {
        return;
    }
    return component.content;
};
exports.getCatalogueComponentContentById = getCatalogueComponentContentById;
